export default __webpack_public_path__ + "static/media/Thunder River Helm.6a53f462.jpg";